import { rolePermissionListByRole } from './Request';

export const fetch = async (roleId = null, state = true) => rolePermissionListByRole(roleId, state);

export default fetch;
